import GoalTypeChip from './GoalTypeChip';

export default GoalTypeChip;
